export default __webpack_public_path__ + "static/media/513.74b3e464.gif";